export const API_ENDPOINT = {
  GUEST_LOGIN: 'https://api.taotaoxi.cn/temp/user/guest-login'
}
